import {
  GET_ORGANIZATION_USERS_REQUEST,
  GET_ORGANIZATION_USERS_SUCCESS,
  GET_ORGANIZATION_USERS_FAILURE
} from '../../actions/Organization/organizationUsersAction';

const initialState = {
  loading: false,
  users: [],
  error: null
};

export default function organizationUsersReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ORGANIZATION_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_ORGANIZATION_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
        error: null
      };
    case GET_ORGANIZATION_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
} 